import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IBroadcast } from '../types/IBroadcast';

export interface IGetDetailBroadcastParams {
    viewLuid: string;
}

export interface IGetDetailBroadcastResult extends IResult {
    broadcast: IBroadcast;
}

export class GetDetailOfABroadcastRequest extends Request<IGetDetailBroadcastParams, IGetDetailBroadcastResult> {
    constructor(params: IGetDetailBroadcastParams) {
        super('getBroadcastView', params);
    }
}